"use client";

import React, { useState } from "react";
import {
  Box,
  Container,
  Typography,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CustomButton from "./CustomButton";

const Footer: React.FC = () => {
  const [openTerms, setOpenTerms] = useState(false);
  const [openHelp, setOpenHelp] = useState(false);
  const [openFAQ, setOpenFAQ] = useState(false);

  return (
    <>
      <Box
        sx={{
          position: "fixed",
          bottom: 0,
          left: 0,
          width: "100%",
          bgcolor: "#989898",
          height: "33px",
          display: "flex",
          alignItems: "center",
          zIndex: 1300,
        }}
      >
        <Container>
          <Typography
            align="center"
            variant="body2"
            fontSize={10}
            color="text.black"
          >
            Flow Tones © 2025. All rights reserved. |{" "}
            <Button
              size="small"
              sx={{ fontSize: 10, color: "#000", textTransform: "capitalize" }}
              onClick={() => setOpenTerms(true)}
            >
              Terms and Conditions
            </Button>{" "}
            |{" "}
            <Button
              size="small"
              sx={{ fontSize: 10, color: "#000", textTransform: "capitalize" }}
              onClick={() => setOpenHelp(true)}
            >
              Help
            </Button>{" "}
            |{" "}
            <Button
              size="small"
              sx={{ fontSize: 10, color: "#000" }}
              onClick={() => setOpenFAQ(true)}
            >
              FAQ
            </Button>
          </Typography>
        </Container>
      </Box>

      <Dialog
        open={openFAQ}
        onClose={() => setOpenFAQ(false)}
        fullWidth
        maxWidth="sm"
        PaperProps={{
          sx: { borderRadius: 2 },
        }}
      >
        <DialogTitle sx={{ fontWeight: 600, fontSize: 16, color: "#1976d2" }}>
          Frequently Asked Questions
          <IconButton
            aria-label="close"
            onClick={() => setOpenFAQ(false)}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers sx={{ fontSize: 14 }}>
          <Typography variant="subtitle1" fontWeight={600} gutterBottom>
            What is Flow Tones?
          </Typography>

          <Typography variant="body2" paragraph>
            Flow Tones is a subscription audio service provided by Flow in your
            market. There are two parts; a Ring Back Tones Store and a Music
            Store.
          </Typography>

          <Typography variant="subtitle1" fontWeight={600} gutterBottom>
            What does CRBT or RBT Mean?
          </Typography>

          <Typography variant="body2" paragraph>
            CRBT means Caller Ring Back Tone (or RBT). It is the sound you hear
            when you call someone before they answer. Typically these are 15–30
            second clips of your favorite songs.
          </Typography>
        </DialogContent>

        <DialogActions>
          <CustomButton text="Close" onClick={() => setOpenFAQ(false)} />
        </DialogActions>
      </Dialog>

      <Dialog
        open={openHelp}
        onClose={() => setOpenHelp(false)}
        fullWidth
        maxWidth="sm"
        PaperProps={{
          sx: { borderRadius: 2 },
        }}
      >
        <DialogTitle sx={{ fontWeight: 600, fontSize: 16, color: "#1976d2" }}>
          Help
          <IconButton
            aria-label="close"
            onClick={() => setOpenHelp(false)}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers sx={{ fontSize: 14 }}>
          <Typography variant="subtitle1" fontWeight={600} gutterBottom>
            Purchase RBT
          </Typography>

          <Typography variant="body2">
            You can purchase RBT from system and can set for anyone
          </Typography>
        </DialogContent>

        <DialogActions>
          <CustomButton text="Close" onClick={() => setOpenHelp(false)} />
        </DialogActions>
      </Dialog>

      <Dialog
        open={openTerms}
        onClose={() => setOpenTerms(false)}
        fullWidth
        maxWidth="sm"
        scroll="paper"
      >
        <DialogTitle sx={{ fontWeight: 600, fontSize: 16, color: "#1976d2" }}>
          Terms and Conditions
          <IconButton
            aria-label="close"
            onClick={() => setOpenTerms(false)}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers sx={{ fontSize: 14 }}>
          <Typography paragraph>
            <strong>About Us - Flow</strong>
          </Typography>

          <Typography paragraph>
            We were the first to connect the Caribbean people, governments and
            businesses with best in class telecoms networks across broadband,
            fixed and mobile services. Today we remain a telecoms tour de force,
            unmatched in every market we serve in the Caribbean as the sole full
            service ‘go to’ provider.
          </Typography>

          <Typography paragraph>
            We value every moment invested in serving our valued customers
            across each of the thirteen markets in the region. We serve Antigua
            & Barbuda, Anguilla, Barbados, British Virgin Islands, Cayman,
            Dominica, Grenada, Jamaica, Montserrat, St. Kitts & Nevis, St.
            Lucia, St. Vincent & the Grenadines and Turks & Caicos Islands.
          </Typography>

          <Typography paragraph>
            <strong>Telemune</strong>
          </Typography>

          <Typography paragraph>
            Founded in 2004, the Telemune team has amassed a wealth of know-how
            and insight into driving revenues for mid-sized mobile operators.
            Telemune has now deployed solutions for over 60 operators in 45
            markets worldwide, with our services reaching 250 million mobile
            users.
          </Typography>

          <Typography paragraph>
            Today, Telemune’s portfolio extends to a range of revenue-driving
            offerings, all delivered over Smart SDP – a single, cost-efficient,
            adaptable VAS platform. Telemune partners closely with its customers
            with a dedicated revenue management team to drive revenue growth and
            ensure market offerings are optimized.
          </Typography>
        </DialogContent>

        <DialogActions>
          <CustomButton text="Ok" onClick={() => setOpenTerms(false)} />
        </DialogActions>
      </Dialog>
    </>
  );
};

export default Footer;
